module.exports = __webpack_public_path__ + "static/media/linkedin.f1b2a501.svg";